import { type CommandProperties, createCommand } from '@atlassian/rovo-content-bridge-api';

import type { ConfluenceAccumulatedDataType } from './confluence-accumulated-data-type';

/**
 * Data payload for creating a Confluence database.
 */
type ConfluenceCreateDatabaseData = ConfluenceAccumulatedDataType & {
	title: string;
	document: string;
	templateType?: string;
};

/**
 * Properties for the Confluence database creation command.
 *
 * @extends CommandProperties
 */
export interface ConfluenceCreateDatabaseCommandProperties extends CommandProperties {
	/**
	 * The unique key identifier for the database creation request.
	 */
	key: string;
	/**
	 * The data payload containing the content for the new database.
	 */
	data: ConfluenceCreateDatabaseData;
	/**
	 * Whether the stream is complete.
	 */
	isStreamComplete: boolean;
}
/**
 * A command sent by a bridge API client to create a new Confluence Database.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to create a Confluence database with the specified content.
 */
export const ConfluenceDatabaseCreateCommand =
	createCommand<ConfluenceCreateDatabaseCommandProperties>('confluence-database-create-command');
